import React, { useEffect, useState } from 'react';
import { Course } from '../types';
import CourseCard from './CourseCard';
import { courseApi } from '../services/api';
import { useTheme } from '../contexts/ThemeContext';

const CourseList: React.FC = () => {
  const { colors } = useTheme();
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const response = await courseApi.getAllCourses();
        setCourses(response.data.data.courses);
        setError(null);
      } catch (err: any) {
        console.error('Error fetching courses:', err);
        setError('Failed to load courses. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2" style={{ borderColor: colors.accent.mint }}></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="mb-4" style={{ color: colors.error.main }}>{error}</p>
        <button 
          onClick={() => window.location.reload()} 
          className="px-4 py-2 rounded transition-all duration-300 hover:scale-105"
          style={{
            background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.accent.mint} 100%)`,
            color: colors.primary.contrastText
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = `linear-gradient(135deg, ${colors.accent.mint} 0%, ${colors.primary.main} 100%)`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.accent.mint} 100%)`;
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <div className="text-center py-8">
        <p style={{ color: colors.text.secondary }}>No courses available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {courses.map((course) => (
        <CourseCard key={course._id} course={course} />
      ))}
    </div>
  );
};

export default CourseList; 